import React, { useRef } from 'react';
import { LinkedIn } from 'react-linkedin-login-oauth2';
import { Button } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

// LinkedIn Client ID - se puede configurar en .env
const LINKEDIN_CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID || '';

const LinkedInLogin = ({ onSuccess, onError, disabled = false }) => {
  const processedCode = useRef(null);
  
  const handleSuccess = (code) => {
    console.log('LinkedIn OAuth success, authorization code received');
    
    // Evitar procesar el mismo código dos veces
    if (processedCode.current === code) {
      console.log('Code already processed, skipping');
      return;
    }
    
    processedCode.current = code;
    onSuccess(code);
  };

  const handleFailure = (error) => {
    console.error('LinkedIn OAuth failed:', error);
    processedCode.current = null; // Reset on error
    onError(error);
  };

  // Si no hay client ID configurado, no mostrar el botón
  if (!LINKEDIN_CLIENT_ID) {
    console.log('LinkedIn Client ID not configured');
    return null;
  }

  return (
    <LinkedIn
      clientId={LINKEDIN_CLIENT_ID}
      onFailure={handleFailure}
      onSuccess={handleSuccess}
      redirectUri={`${window.location.origin}/linkedin`}
      scope="openid profile email"
      state="random_string" // Para prevenir CSRF
      supportIE
      redirectPath="/linkedin"
    >
      {({ linkedInLogin }) => (
        <Button
          fullWidth
          variant="outlined"
          onClick={linkedInLogin}
          disabled={disabled}
          startIcon={<LinkedInIcon sx={{ fontSize: '20px' }} />}
          sx={{
            py: 1.5,
            px: 3,
            borderColor: '#0077B5',
            borderRadius: '8px',
            color: '#0077B5',
            fontSize: '14px',
            fontWeight: 500,
            textTransform: 'none',
            transition: 'all 0.3s ease',
            background: 'white',
            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
            '&:hover': {
              borderColor: '#005885',
              backgroundColor: 'rgba(0, 119, 181, 0.08)',
              boxShadow: '0 1px 3px 0 rgba(0, 119, 181, 0.3)',
              transform: 'translateY(-1px)',
            },
            '&:active': {
              transform: 'translateY(0)',
            },
            '&:disabled': {
              borderColor: 'rgba(0, 0, 0, 0.12)',
              color: 'rgba(0, 0, 0, 0.26)',
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          Continue with LinkedIn
        </Button>
      )}
    </LinkedIn>
  );
};

export default LinkedInLogin;
